<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <a-spin :spinning="loading">
            <navbar :back_path="back_path || '/privilege'" :navbar_sub_visible="$device != 'mobile'" active_screen="privilege" :content_title="privilege_detail.title" />
            <div style="background-color: #fff; width: 100vw">
                <div style="justify-content: space-between; display: flex">
                    <label class="title"> กรุณาเลือกคูปองที่ต้องการ </label>
                </div>
                <div style="width: 100%; padding: 0px 16px 16px 16px">
                    <div
                        v-for="(choice, idx) in privilege_detail.choices"
                        :key="idx"
                        class="text-center"
                        @click="choice.remain > 0 ? handleChoice(choice) : ''"
                        :style="{
                            margin: '16px 0 0 0',
                            padding: '12px',
                            color: choice.remain > 0 ? '#fff' : '#000',
                            backgroundColor: choice.remain > 0 ? '#ff7105' : '#A8A9AD',
                        }"
                    >
                        <span style="font-size: 16px; font-weight: 300; display: block">{{ choice.label_top }}</span>
                        <span style="font-size: 16px; font-weight: 300; display: block">{{ choice.label }}</span>
                    </div>
                </div>
            </div>
            <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :data="modal_data" @on-save="onModalSave" @on-cancel="onModalCancel" />
            <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
        </a-spin>
    </a-spin>
</template>
<script>
import store from 'store';
import navbar from '../../components/navbar';
import modalForm from './modalForm';
export default {
    components: {
        navbar,
        modalForm,
    },
    data: function () {
        return {
            getting_data: true,
            loading: false,
            modal_visible: false,
            modal_data: {},
            privilege_detail: {},
            priv_id: this.$route.query.priv_id,
        };
    },
    mounted() {
        this._mounted();
        console.log('this.$route.query', this.$route.query);
    },
    methods: {
        _mounted: function () {
            this.getPrivilegeChoice(() => (this.getting_data = false));
        },
        getPrivilegeChoice: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/privilege/detail',
                    data: {
                        priv_id: this.priv_id,
                    },
                    callback: (res) => {
                        if (res) {
                            this.privilege_detail = res;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        handleChoice(choice) {
            this.modal_data.label = true;
            this.modal_data.choice = choice;
            this.modal_data.choice.count_time = this.privilege_detail ? this.privilege_detail.count_time : 0;
            this.modal_data.step = 'confirm';
            console.log(' this.modal_data', this.modal_data);
            this.modal_visible = true;
        },
        onModalSave() {
            this.modal_visible = false;
            this.getPrivilegeGenerate(() => (this.getting_data = false));
            // this.$router.replace({
            //   path: '/privilege-generate',
            //   query: {
            //     priv_id: this.priv_id,
            //     package_id: null,
            //     choice_id: this.modal_data.choice
            //       ? this.modal_data.choice.choice_id
            //       : null,
            //   },
            // });
        },
        getPrivilegeGenerate: function (callback = null) {
            this.loading = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/privilege/generate',
                    data: {
                        priv_id: this.priv_id,
                        package_id: null,
                        choice_id: this.modal_data.choice ? this.modal_data.choice.choice_id : null,
                    },
                    callback: (res) => {
                        console.log('generate res-->', res);
                        if (res && res.result == 'errors') {
                            console.log('error---->');
                            const complete = {
                                title: '',
                            };
                            for (const [, value] of Object.entries(res.errors)) {
                                complete.title += value[0];
                            }
                            // if (this.$mode == 'production') {
                            this.modal_visible = true;
                            this.modal_data.step = 'error_generate';
                            this.modal_data.message = complete.title;
                            // }
                        } else {
                            store.set('privilege_generate', res);
                            this.r('/privilege-generate', {
                                priv_id: this.priv_id,
                                package_id: null,
                                choice_id: this.modal_data.choice ? this.modal_data.choice.choice_id : null,
                            });
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        onModalCancel() {
            this.modal_visible = false;
        },
    },
};
</script>
<style scoped>
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
}
.image {
    width: 100%;
}
.title {
    font-size: 16px;
    font-weight: 600;
    margin: 8px 8px 0 16px;
    color: #000 !important;
}
.description {
    font-size: 14px;
    font-weight: 300;
    margin: 0 0 0 16px;
    color: #ffffff !important;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.description-read-all {
    font-size: 16px;
    font-weight: 300;
    margin: 0 0 0 16px;
    color: #707070 !important;
}
.read-all {
    font-size: 14px;
    font-weight: 300;
    margin: 8px 0 8px 0;
    color: #707070 !important;
}
.half-circle {
    width: 50px;
    height: 25px; /* as the half of the width */
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    /* border: 10px solid gray; */
    border-top: 0;
    box-shadow: #707070 0px 25px 40px 0px;
    margin: 0 auto;
}
/* .vue-confirm-dialog {
}
.vue-confirm-dialog .vc-container .vc-text-grid .vc-title {
  font-size: 16px !important;
}
.vc-title {
  font-size: 16px !important;
} */
</style>
